import React from 'react';
import OutlinedTypography from './OutlinedTypography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(32),
    },
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
  },
}));

const SectionTitle = ({ title, subtitle }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <OutlinedTypography classes={{ root: classes.title }}>
        {title}
      </OutlinedTypography>
      <Typography variant="h2" className={classes.subtitle}>
        {subtitle}
      </Typography>
    </div>
  );
};

export default SectionTitle;
